import React from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";

export const AssignmentsOrQuizzesToggle = ({
  assignmentsOrQuizzes,
  setAssignmentsOrQuizzes,
}) => {
  const handleChange = (_, newValue) => {
    if (newValue !== null) {
      setAssignmentsOrQuizzes(newValue);
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        mt: 2,
      }}
    >
      <ToggleButtonGroup
        value={assignmentsOrQuizzes}
        exclusive
        onChange={handleChange}
        size="small"
        sx={{
          backgroundColor: "action.hover",
          borderRadius: 999,
          p: 0.2,
          height: 35,
          "& .MuiToggleButton-root": {
            border: "none",
            borderRadius: 999,
            px: 2,
            textTransform: "none",
          },
          "& .Mui-selected": {
            backgroundColor: "primary.main",
            color: "primary.contrastText",
            "&:hover": {
              backgroundColor: "primary.dark",
            },
          },
        }}
      >
        <ToggleButton value={"Assignments"}>Assignments</ToggleButton>
        <ToggleButton value={"Quizzes"}>Quizzes</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};
